module.exports = __webpack_public_path__ + "img/studio.830af36f.png";